import { render, staticRenderFns } from "./LineTableInvoice.vue?vue&type=template&id=c144dc72&scoped=true&"
import script from "./LineTableInvoice.vue?vue&type=script&lang=js&"
export * from "./LineTableInvoice.vue?vue&type=script&lang=js&"
import style0 from "./LineTableInvoice.vue?vue&type=style&index=0&id=c144dc72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c144dc72",
  null
  
)

export default component.exports